import { Link } from "react-router-dom";
import { Reveal } from "./motion-primitives";

const BLOCKS = [
  {
    title: "Places we know firsthand",
    body: "Our published destination edits draw on places we've personally experienced. Look for the Holideviser Verified label on individual recommendations.",
  },
  {
    title: "Trips shaped around you",
    body: "For a tailored holiday, we combine your preferences with options from destination partners, then review the plan with you. Partner-supplied services are not automatically personally verified.",
  },
];

export const Manifesto = () => {
  return (
    <section
      id="approach"
      data-testid="manifesto-section"
      className="relative overflow-hidden border-y border-charcoal py-16 lg:py-20"
    >
      <div className="relative mx-auto max-w-[1400px] px-6 sm:px-10 lg:px-16">
        <Reveal>
          <span className="font-sans text-xs uppercase tracking-[0.3em] text-teal">
            The Holideviser approach
          </span>
        </Reveal>

        <Reveal delay={0.08}>
          <h2
            data-testid="manifesto-statement"
            className="mt-8 max-w-4xl font-serif text-5xl font-light leading-[1.02] tracking-tight text-cream sm:text-6xl lg:text-7xl"
          >
            A point of view. <span className="italic text-teal">A plan that fits.</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-12 md:grid-cols-2 lg:mt-16 lg:max-w-5xl lg:gap-16">
          {BLOCKS.map((b, i) => (
            <Reveal key={b.title} delay={i * 0.1}>
              <div className="flex flex-col gap-4 border-t border-charcoal pt-6">
                <span className="font-sans text-xs uppercase tracking-[0.24em] text-cream">{b.title}</span>
                <p className="font-serif text-xl font-light leading-snug text-cream/90 sm:text-2xl">
                  {b.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-12 max-w-2xl font-sans text-base leading-relaxed text-sand">
            The destination edits are a starting point. If you have somewhere else in mind, tell us — we'll
            confirm whether we can help.
          </p>
        </Reveal>
        <Reveal delay={0.26}>
          <Link
            to="/destinations"
            data-testid="approach-destinations-link"
            className="mt-6 inline-flex items-center gap-2 border-b border-teal pb-1 font-sans text-sm uppercase tracking-[0.18em] text-cream transition-colors hover:text-teal"
          >
            Explore our destination edits
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
